import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import HomePage from "./pages/Home";
import SongPage from "./pages/Song";
import VotePage from "./pages/Vote";
import Final from "./pages/Final";
import Welcome from "./pages/Welcome";
import SubmissionPage from "./pages/Submission";
import Ads from "./pages/Ads";
import Skipline from "./pages/Skipline";
import SongStats from "./pages/SongStats";
import FAQ from "./pages/faq";
import Referral from "./pages/Referral"
import NewHome from "./pages/NewHome"
import ContestIntroduction from "./pages/ContestIntroduction"
import "./index.css";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/home" element={<NewHome />} />
        {/* With contest id */}
        <Route path="/contest/:contestId" element={<ContestIntroduction />}></Route>
        <Route path="/round/:id/:contestId" element={<VotePage />}></Route>
        <Route path="/final/:contestId" element={<Final />}></Route>
        <Route path="/song/:id/:contestId" element={<SongPage />} />
        {/* FAQ */}
        <Route path="/faq" element={<FAQ />} />
        {/* Referral */}
        <Route path="/referral" element={<Referral />} />
        {/* Channels */}
        <Route path="/genre/:id" element={<HomePage />} />
        {/* Onboarding artists */}
        <Route path="/welcome" element={<Welcome />} />
        {/* SongStats Page */}
        <Route path="/get-stats" element={<SongStats />}></Route>
        {/* Submission page */}
        <Route path="/submission" element={<SubmissionPage />}></Route>
        {/* Ads Register Page */}
        <Route path="/ads" element={<Ads />}></Route>
        {/* Skip line page */}
        <Route
          path="/skiptheline"
          element={<Navigate to="/skipline" replace />}
        />
        <Route path="/skipline" element={<Skipline />}></Route>
        {/* Redirect another other routes to home page */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      
    </BrowserRouter>
  );
}

export default App;
